import { Container, Typography } from '@mui/material';
import React from 'react';
import DevicesTable from './devicesTable';
import Device from '../../models/device';
import UserFetch from '../../userFetch';
import { refreshDevicesKeyboardShortcuts } from '../../keyboardShortcuts';
import { useContextSelector } from 'use-context-selector';
import { DeviceProvider, DevicesContext } from './deviceContext';

const DevicePage = function ({ userId, isSuperAdmin }: { userId: string; isSuperAdmin?: boolean }) {
  const dispatch = useContextSelector(DevicesContext, (c) => c.dispatch);
  const reloadNeeded = useContextSelector(DevicesContext, (c) => c.state.reloadNeeded);

  const fetchDevices = () => {
    UserFetch('/api/devices')
      .then(async (response) => {
        const jdevice: any[] = await response.json();

        const devices = jdevice.map((d) => {
          const device = d as Device;
          device.command = {
            operation: d.command_operation,
            requested: d.command_requested,
            fetched: d.command_fetched,
            completed: d.command_completed,
            result: d.command_result,
            success: d.command_success,
            requested_by: d.command_requested_by
          }
          return device;
        });

        dispatch({
          type: 'SET_DEVICES',
          payload: devices
        });
      });
  }

  React.useEffect(() => {
    if (reloadNeeded) {
      fetchDevices();
    }
  }, [reloadNeeded]);

  refreshDevicesKeyboardShortcuts(fetchDevices);

  return (
    <Container maxWidth={false} sx={{ py: 0 }}>
      <DevicesTable userId={userId} isSuperAdmin={isSuperAdmin} />
    </Container>
  );
}

export default React.memo(DevicePage);